import * as React from "react";
import { Input } from "@/components/ui/input";

// Muestra la hora en local (HH:MM) pero emite ISO 8601 UTC al onChange.
export const TimeField = React.forwardRef(
  ({ value, onChange, className, ...props }, ref) => {
    const toLocal = (iso) => {
      if (!iso) return "";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return "";
      return `${String(d.getHours()).padStart(2, "0")}:${String(
        d.getMinutes()
      ).padStart(2, "0")}`;
    };
    const handle = (e) => {
      const v = e.target.value; // HH:MM (local)
      if (!v) return onChange?.(null);
      const [h, m] = v.split(":");
      const d = new Date();
      d.setHours(Number(h), Number(m), 0, 0);
      onChange?.(d.toISOString());
    };
    return (
      <Input
        ref={ref}
        type="time"
        value={toLocal(value)}
        onChange={handle}
        className={className}
        {...props}
      />
    );
  }
);
TimeField.displayName = "TimeField";
